import { render, staticRenderFns } from "./OptionsPickAnswer.vue?vue&type=template&id=1ceccdee&scoped=true&"
import script from "./OptionsPickAnswer.vue?vue&type=script&lang=js&"
export * from "./OptionsPickAnswer.vue?vue&type=script&lang=js&"
import style0 from "./OptionsPickAnswer.vue?vue&type=style&index=0&id=1ceccdee&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ceccdee",
  null
  
)

export default component.exports